import { Divider, Stack } from '@mui/material';
import FieldSkeleton from '/@/components/field-skeleton';
import { FIELD_LIST_SKELETON_COUNT } from './constants';

function FieldSelectSkeletonList({ minHeight }: { minHeight?: string | number }) {
    return (
        <Stack divider={<Divider flexItem />} minWidth='30%' minHeight={minHeight}>
            {[...Array(FIELD_LIST_SKELETON_COUNT)].map((_, i) => (
                <FieldSkeleton key={i} />
            ))}
        </Stack>
    );
}

export default FieldSelectSkeletonList;
